import { render, staticRenderFns } from "./editModules.vue?vue&type=template&id=3edaa4fe&scoped=true&"
import script from "./editModules.vue?vue&type=script&lang=js&"
export * from "./editModules.vue?vue&type=script&lang=js&"
import style0 from "./editModules.vue?vue&type=style&index=0&id=3edaa4fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3edaa4fe",
  null
  
)

export default component.exports